import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  DeleteUserPreferenceRequest,
  GetPreferenceResponse,
} from '../types';

type ApiEnvelope<T> = { data: T };

export const deleteUserPreference = async <T extends Record<string, unknown>>(
  params: DeleteUserPreferenceRequest,
): Promise<GetPreferenceResponse<T>> => {
  const { boardId, key } = params;
  const url = `/api/v2/boards/${boardId}/preferences/${encodeURIComponent(key)}/user`;

  const response =
    await apiAuthClient.delete<ApiEnvelope<GetPreferenceResponse<T>>>(url);
  return response.data.data;
};
